import { FC, MutableRefObject, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

const SectionOverlayWrapper: FC<PropsWithChildren & { inputRef?: MutableRefObject<null>; className?: string }> = ({
    children,
    inputRef,
    className = '',
  }) => (
    <div
      ref={inputRef}
      className={twMerge(
        className,
        'tw-absolute tw-bottom-0 tw-left-0 tw-z-10 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-bg-[rgba(14,38,89,0.9)]'
      )}
    >
      <div className="tw-inline-flex tw-h-full tw-flex-col tw-items-center tw-gap-y-4 tw-pt-48">{children}</div>
    </div>
  );
  
  export default SectionOverlayWrapper;
  